import * as React from 'react';
import { CartSeat } from '../../../classes/seat';
import { getCurrencyFormat } from '../../../helpers/currency-format';
import { Html } from '../../../helpers/html-helpers';

export interface ICartItemsProps {
    cartSeats: Array<CartSeat>;
    cartSubtotalLabel: string;
    currencyFormat: string;
    exchangeFreeLabel: string;
    hidePricesInCart: boolean;
    subpackageHideMessage: string;
    displaySeatFee?: boolean;
}

// List of cart items (LineItem components) and subtotal
class SubtotalItems extends React.Component<ICartItemsProps, { seatToRemove: CartSeat }> {
    render() {

        return (
            <div className="overlay-section-subtotal-content caption-paragraph">
                {
                    this.props.hidePricesInCart ? Html.renderParagraph(this.props.subpackageHideMessage) :
                        <>
                            <span>{this.props.cartSubtotalLabel}</span>
                            <span className="subtotal">{this.cartSubTotal}</span>
                        </>
                }


            </div>

        );
    }



    get cartSubTotal(): string {

        const total = this.props.cartSeats.map(seat => this.addFee(seat)).reduce((sum, n) => sum + n, 0);

        if (total > 0 || this.props.exchangeFreeLabel === "") {
            return getCurrencyFormat(this.props.currencyFormat, total);
        }

        if (this.props.exchangeFreeLabel.length > 0 && this.props.cartSeats.length > 0) {
            return this.props.exchangeFreeLabel;
        }

        return '$0.00';
    }

    addFee(seat) {
        if (this.props?.displaySeatFee) {
            return seat.selectedPricing.priceCarted + seat.selectedPricing.feeAmount;
        }

        return seat.selectedPricing.priceCarted;
    }

}

export default SubtotalItems;